'use strict';

angular.module('imagetrend.components')
    .controller('hlpCliniciansImportController', ['$scope', '$rootScope', '$uibModal', 'Clinicians', 'Documents',
        function ($scope, $rootScope, $uibModal, Clinicians, Documents) {
            $scope.preview = false;
            if ($rootScope.isPortal && $rootScope.isPortal == "True") {
                if ($rootScope.enterprise && $rootScope.enterprise.website) {
                    $scope.portalURL = $rootScope.enterprise.website;
                }
                else {
                    $scope.portalURL = $rootScope.portalURL;
                }
            }
            else {
                if ($rootScope.enterprise && $rootScope.enterprise.site_location) {
                    $scope.portalURL = $rootScope.enterprise.site_location;
                }
                else {
                    $scope.portalURL = $rootScope.internalURL;
                }
            }

            if ($scope.parameters.response_id) {
                Clinicians.getDocumentByResponseID($scope.parameters.response_id).then(function (document_id) {
                    if (document_id) {
                        Documents.getByID(document_id).then(function (file) {
                            $scope.fileUpload = {
                                file_name: file.file_name,
                                document_id: file.id,
                                document_code: file.code,
                                service_id: $scope.parameters.service_id
                            };
                            $scope.component.elementAnswer = [$scope.fileUpload];
                        });
                    }
                    else {
                        $scope.fileUpload = {
                            file_content: null,
                            file_name: null,
                            service_id: $scope.parameters.service_id
                        };
                        $scope.component.elementAnswer = [$scope.fileUpload];
                    }
                });
            } else {
                $scope.fileUpload = {
                    file_content: null,
                    file_name: null,
                    service_id: $scope.parameters.service_id
                };
                $scope.component.elementAnswer = [$scope.fileUpload];
            }

            $scope.downloadClinicians = function () {
                $scope.downloading = true;
                if ($scope.parameters.service_id) {
                    Clinicians.downloadExcel($scope.parameters.service_id).then(function (data) {
                        data = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," + data;
                        var link = document.createElement("a");
                        link.href = data;
                        link.download = "clinicians.xlsx"
                        link.click();

                        $scope.downloading = false;
                    });
                }
                else {
                    //Form is in preview mode
                    $scope.downloading = false;
                    $scope.preview = true;
                }
            }

            $scope.importClinicians = function () {
                $uibModal.open({
                    animation: true,
                    templateUrl: 'templates/clinicians-import/clinicians-import-modal.html',
                    controller: 'ImportCliniciansModalController',
                    resolve: {
                    }
                }).result.then(function (upload) {
                    if (upload != null) {
                        $scope.fileUpload.file_content = upload.file_content;
                        $scope.fileUpload.file_name = upload.file_name;
                        $scope.fileUpload.file_updated = true;
                        $scope.fileUpload.saved = false;
                        $scope.component.elementAnswer = [$scope.fileUpload];
                    }
                });
            }
        }])
    .directive('hlpCliniciansImport', [function () {
        return {
            restrict: 'E',
            templateUrl: 'templates/clinicians-import/clinicians-import.html',
            replace: true,
            controller: 'hlpCliniciansImportController',
            scope: {
                parameters: '=?',
                component: '=?'
            },
            link: function (scope, elem, attrs, ctrl) {

            }
        };
    }])
    ;